import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog6deleteDeleteCatalogDraftsCurrentTestCasesTestCaseKeyResponseSchema = jsonObject
export type tcpcatalog6deleteDeleteCatalogDraftsCurrentTestCasesTestCaseKeyResponse = z.infer<typeof tcpcatalog6deleteDeleteCatalogDraftsCurrentTestCasesTestCaseKeyResponseSchema>
